import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OpsOrderFragmentDoc } from '../fragments/opsOrder.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpsOrdersSearchQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  sort?: Types.InputMaybe<Types.OpsOrderSort>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type OpsOrdersSearchQuery = { __typename?: 'Query', opsOrdersSearch: { __typename?: 'OpsOrdersSearchResponse', total: number, items: Array<{ __typename?: 'OpsOrder', id: string, type?: Types.MerchantOrderTypeEnum | null, system: string, container_types_used: Array<number>, status: Types.MerchantOrderStatusEnum, city: string, country: string, comment?: string | null, created_at: string, created_by_user_name?: string | null, health: Types.OpsOrderHealthEnum, carrier?: Types.OpsOrderCarrier | null, last_updated: string, delivery_date?: string | null, delivery_note_id?: number | null, total_amount: number, language?: string | null, order_execution_date?: string | null, carrier_pickup_date?: string | null, order_form_id?: string | null, store_tier?: string | null, store_type?: string | null, target_store_user_id?: string | null, store?: { __typename?: 'TextIdName', name: string, text_id?: string | null } | null, created_by?: { __typename?: 'IdName', id: string, name: string } | null, warehouse?: { __typename?: 'TextIdName', name: string, text_id?: string | null } | null, item_locations: Array<{ __typename?: 'OpsOrderItemLocation', id: string, name?: string | null }>, containers: Array<{ __typename?: 'OpsOrderSearchContainer', amount: number, order_key?: number | null, type_name: string }>, untracked_items: Array<{ __typename?: 'OpsOrderSearchUntrackedItem', amount: number, order_key?: number | null, type_name: string }>, items: Array<{ __typename?: 'OpsOrderSearchItem', amount: number, order_key?: number | null, type_name: string }>, delivery_address?: { __typename?: 'DeliveryAddressInfo', id: string, additional_info?: string | null, city?: string | null, company?: string | null, country?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, name?: string | null, phone_number?: string | null, streetname?: string | null, streetno?: string | null, zip?: string | null } | null, event?: { __typename?: 'IdName', id: string, name: string } | null, event_account?: { __typename?: 'IdName', id: string, name: string } | null, box_counts: Array<{ __typename?: 'OpsOrderBoxCount', box_size: string, count: number }> }> } };


export const OpsOrdersSearchDocument = gql`
    query OpsOrdersSearch($filter: OpsOrderFilter, $sort: OpsOrderSort, $take: Int, $skip: Int) {
  opsOrdersSearch(filter: $filter, sort: $sort, take: $take, skip: $skip) {
    items {
      ...OpsOrder
    }
    total
  }
}
    ${OpsOrderFragmentDoc}`;

/**
 * __useOpsOrdersSearchQuery__
 *
 * To run a query within a React component, call `useOpsOrdersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsOrdersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsOrdersSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOpsOrdersSearchQuery(baseOptions?: Apollo.QueryHookOptions<OpsOrdersSearchQuery, OpsOrdersSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpsOrdersSearchQuery, OpsOrdersSearchQueryVariables>(OpsOrdersSearchDocument, options);
      }
export function useOpsOrdersSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpsOrdersSearchQuery, OpsOrdersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpsOrdersSearchQuery, OpsOrdersSearchQueryVariables>(OpsOrdersSearchDocument, options);
        }
export type OpsOrdersSearchQueryHookResult = ReturnType<typeof useOpsOrdersSearchQuery>;
export type OpsOrdersSearchLazyQueryHookResult = ReturnType<typeof useOpsOrdersSearchLazyQuery>;
export type OpsOrdersSearchQueryResult = Apollo.QueryResult<OpsOrdersSearchQuery, OpsOrdersSearchQueryVariables>;